import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { AssessmentCriteria, Course, UserType } from '@shared/models';

@Component({
  selector: 'program-reporting-reports',
  templateUrl: './program-reporting-reports.component.html',
  styleUrls: ['./program-reporting-reports.component.scss'],
  animations: fuseAnimations
})

export class ProgramReportingReportsComponent implements OnInit {
  @Input() course: Course;
  @Output() onOpenSessionLog = new EventEmitter<{ sessionId: string, userName: string, course: Course }>();
  @Input() selectedUserType: UserType;
  @Output() onUserTypeChange = new EventEmitter<UserType>();
  public criteriaArray: [number, AssessmentCriteria][];

  constructor() {}

  ngOnInit(): void {
    this.criteriaArray = this.course.information?.assessment?.criterias?.map((c, index) => [index, c]) || [];
  }

  onExplore(event: any) {
    this.onOpenSessionLog.emit(event);
  }
}
